import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const loginService = (data, callback) => setupService("user/login", "POST", false, data, callback);
export const resetPasswordService = (data, callback) => setupService("user/reset-password", "POST", false, data, callback);
export const updatePasswordService = (data, callback) => setupService("user/update-password", "PUT", false, data, callback);
export const userService = (callback) => setupService("user/list", "GET", true, null, callback);
export const userGetService = (id, callback) => setupService(`user/${id}`, "GET", true, null, callback);
export const userUpdateService = (data, callback) => setupService("user/update", "PUT", true, data, callback);
export const registerUserService = (data, callback) => setupService("user/register", "POST", false, data, callback);
export const pingstationListService = (callback) => setupService("pingstation/list", "GET", true, null, callback);
export const pingstationGetService = (id, callback) => setupService(`pingstation/get/${id}`, "GET", true, null, callback);
export const pingstationUpdateService = (data, callback) => setupService("pingstation/update", "PUT", true, data, callback);
export const broadcastListService = (callback) => setupService("psg/list", "GET", true, null, callback);
export const broadcastGetService = (id, callback) => setupService(`psg/get/${id}`, "GET", true, null, callback);
export const broadcastUpdateService = (data, callback) => setupService("psg/update", "PUT", true, data, callback);
export const broadcastCreateService = (data, callback) => setupService("psg/create", "POST", true, data, callback);
export const analyticsListService = (data, callback) => setupService("analytics/list", "GET", true, data, callback);

const setupService = async (slug, method, requiresLogin, data, cb) => {
    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
    };

    const loginToken = localStorage.getItem("token");

    if (requiresLogin && loginToken) {
        headers["Authorization"] = `Bearer ${loginToken}`;
    }
    // try {
    //     const response = await fetch(`${API_URL}${slug}`, {
    //         method: method,
    //         headers: headers,
    //         body: data ? JSON.stringify(data) : null,
    //     });
    //     if (response.ok) {
    //         const json = await response.json();
    //         if (cb) {
    //             cb(json);
    //         }
    //         return json;
    //     }
    //     throw new Error("Network response was not ok.");
    // } catch (error) {
    //     console.error("There was a problem with your fetch operation:", error.message);
    // }


    try {
        if (method === "GET") {
            await axios.get(`${API_URL}${slug}`, { headers, params: data || {} }).then((response) => {
                const json = response.data;
                if (cb) {
                    cb(json);
                }
                return json;
            }).catch((error) => {
                cb(error.response.data || { success: false, message: error.message });
            });
        } else if (method === "POST") {
            await axios.post(`${API_URL}${slug}`, data, { headers }).then((response) => {
                const json = response.data;
                if (cb) {
                    cb(json);
                }
                return json;
            }).catch((error) => {
                cb(error.response.data || { success: false, message: error.message });
            });
        } else if (method === "PUT") {
            await axios.put(`${API_URL}${slug}`, data, { headers }).then((response) => {
                const json = response.data;
                if (cb) {
                    cb(json);
                }
                return json;
            }).catch((error) => {
                cb(error.response.data || { success: false, message: error.message });
            });
        } else if (method === "DELETE") {
            await axios.delete(`${API_URL}${slug}`, { headers }).then((response) => {
                const json = response.data;
                if (cb) {
                    cb(json);
                }
                return json;
            }).catch((error) => {
                cb(error.response.data || { success: false, message: error.message });
            });
        }
    } catch (error) {
       cb({ success: false, message: error.message });
    }
}